import { isRecord } from 'src/modules/shared/utils/types.util';
import { formatUnknownValue } from 'src/modules/shared/utils/formatting/unknown-value.util';
import type {
  NormalizedDefinition,
  StepsMap,
  WorkflowVersionDefinition,
} from './workflow-definition.type';

/**
 * Normalizes a raw workflow definition into a consistent structure with steps,
 * initial step ID, and optional final step.
 */
export const normalizeDefinition = (
  definition: unknown
): NormalizedDefinition => {
  const def = isRecord(definition) ? definition : {};

  const stepsRaw = def.steps;
  const steps: StepsMap =
    stepsRaw && typeof stepsRaw === 'object' ? (stepsRaw as StepsMap) : {};

  const initialStepId =
    typeof def.initialStepId === 'string' ? def.initialStepId : undefined;

  let finalStep: WorkflowVersionDefinition['finalStep'];
  if (def.finalStep && typeof def.finalStep === 'object') {
    const fs = def.finalStep as Record<string, unknown>;
    finalStep = {
      id: formatUnknownValue(fs.id),
      actionId: formatUnknownValue(fs.actionId),
      inputs: isRecord(fs.inputs) ? fs.inputs : {},
      description:
        typeof fs.description === 'string' ? fs.description : undefined,
    };
  }

  return { steps, initialStepId, finalStep };
};
